import { Typography } from 'design-system/src/components/Typography/Typography';
import styled from 'styled-components';

const Subtitle = styled(Typography)`
  color: var(--dark-gray);
`;

export type SignupFlowContentProps = {
  variant?: 'default' | 'demo';
};

export const SignupFlowContent = ({ variant = 'default' }: SignupFlowContentProps) => {
  if (variant === 'demo') {
    return (
      <>
        <Typography styledAs="h4" weight="500" marginBottom={24}>
          See how Tandem works
        </Typography>
        <Typography styledAs="bodyLargeDMSans" marginBottom={48}>
          Schedule an expert-run, 30 minute tour of the platform.
        </Typography>
      </>
    );
  }

  return (
    <>
      <Typography styledAs="h4" weight={500}>
        Get prior auths off your plate.
      </Typography>
      <Subtitle styledAs="bodyLargeDMSans">
        Tandem uses AI to handle prior authorizations, affordability, and pharmacy coordination.
      </Subtitle>
    </>
  );
};

export default SignupFlowContent;
